import { LottieViewProps } from "lottie-react-native";
import React from "react";
import { ViewStyle } from "react-native";
import LottieWeb from "lottie-react";
export type LottieRef = {
  play(startFrame?: number, endFrame?: number): void;
  reset(): void;
  pause(): void;
  resume(): void;
};

type OmitNever<T extends Record<string, unknown>> = {
  [K in keyof T as T[K] extends never ? never : K]: T[K];
};

type SharedProperties<A, B> = OmitNever<Pick<A & B, keyof A & keyof B>>;

type Props = Omit<LottieViewProps, "style"> & {
  style?: SharedProperties<ViewStyle, React.CSSProperties>;
  autoSize?: boolean;
  ref?: React.RefObject<LottieRef | null>;
};

export const Lottie = ({ ref, ...props }: Props) => {
  const { source, style, autoSize, ...rest } = props;
  return (
    <LottieWeb
      animationData={source}
      {...rest}
      style={{ height: "100%", ...style }}
    />
  );
};
